module.exports = __webpack_public_path__ + "static/img/Frame_4269@2x.6c6f4f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/serviceImg/service/Frame_4269@2x.png
// module id = r81Y
// module chunks = 64